// extracted by mini-css-extract-plugin
module.exports =  {"contentLayout":"contentLayout__MeLt8 proposalContent__o4P6i","success":"success__-C0QA"};